import React, {useState, useEffect} from 'react';
import {languages} from "../../constants";
import {Table, Tag, Button, Input} from "antd";
import OutputFile from "./OutputFile";
import {EditOutlined, SearchOutlined} from "@ant-design/icons";
import {Col, Row} from "reactstrap";
import {values} from "lodash";

const {Column} = Table;

const RequestListView = ({tableData, tblLoader, admin, editRequest}) => {

    const [requestsData, setRequestData] = useState([])

    useEffect(() => {
        tableData && tableData.length && setRequestData(tableData);
    }, [tableData])

    const searchHandler = (event) => {
        const searchString = event.target.value;
        // const reg = new RegExp(searchString, "gi");
        const filteredData = tableData.filter(({fileLink, email, requestStatus, sourceLanguage, targetLanguage, output})=> {
            const rowValue = fileLink + email + requestStatus + getLanguageName(sourceLanguage) + getLanguageName(targetLanguage) + output;
            return rowValue.toLowerCase().includes(searchString.toLowerCase())
        });
        setRequestData(filteredData);
    }

    const getLanguageName = (text)=>{
        const language = languages.find((lg) => {
            return lg.language === text;
        })
        return language ? language.name : "";
    }

    return (
        <>
            <Row style={{marginBottom: '10px'}}>
                <Col xs="4">
                    <Input size="large" placeholder="Search" onChange={searchHandler} prefix={<SearchOutlined/>}/>
                </Col>
            </Row>
            <Row>
                <Col xs="12">
                    <Table
                        bordered
                        scroll={{x: 1300}}
                        dataSource={requestsData}
                        loading={tblLoader}
                    >
                        <Column
                            title="Created Date"
                            key="createdAt"
                            width={120}
                            dataIndex="createdAt"
                            render={(text, record) => {
                                const created = new Date(text);
                                const fullDate = `${created.getDate()}/${
                                    created.getMonth() + 1
                                }/${created.getFullYear()}`;
                                return <span>{fullDate}</span>;
                            }}
                        />
                        <Column
                            title="Status"
                            width={150}
                            key="requestStatus"
                            dataIndex="requestStatus"
                            render={(text, record) => {
                                text = record.requestStatus || record.status || "unavailable";
                                switch (text.toLowerCase()) {
                                    case "open":
                                        return <Tag color="blue">{text}</Tag>;
                                    case "human transcribed":
                                    case "human translated":
                                    case "in progress":
                                    case "machine transcribed":
                                    case "machine translated":
                                    case "downloading":
                                        return (
                                            <Tag className="text-capitalize" color="orange">
                                                {text}
                                            </Tag>
                                        );
                                    // case "default":
                                    //   return <Tag>{text}</Tag>;
                                    case "done":
                                        return (
                                            <OutputFile
                                                type="finalOutput"
                                                file={record.outputLink || null}
                                            />
                                        );
                                    default:
                                        return <Tag color="red">Contact Us</Tag>;
                                }
                            }}
                        />
                        <Column //make this into a download link for the input file
                            title="File Name"
                            key="fileName"
                            width={380}
                            render={(data) => {
                                if (data.fileLink) {
                                    const file = data.fileLink.split("/");
                                    const fileName = file[file.length - 1];
                                    return <span>{fileName}</span>;
                                } else if (data.externalVideoData && data.externalVideoData.name) {
                                    return <span>{data.externalVideoData.name}</span>;
                                }
                                return <span>{"N/A"}</span>;
                            }}
                        />
                        <Column
                            title="User"
                            width={250}
                            key="email"
                            dataIndex="email"
                        />
                        <Column
                            title="Source Language"
                            dataIndex="sourceLanguage"
                            key="sourceLanguage"
                            width={150}
                            render={(text) => {
                                const sourceLanguage = languages.find((lg) => {
                                    return lg.language === text;
                                });
                                return <span>{sourceLanguage ? sourceLanguage.name : text}</span>;
                            }}
                        />
                        <Column
                            title="Target Language"
                            dataIndex="targetLanguage"
                            key="targetLanguage"
                            width={150}
                            render={(text) => {
                                const sourceLanguage = languages.find((lg) => {
                                    return lg.language === text;
                                });
                                return <span>{sourceLanguage ? sourceLanguage.name : text}</span>;
                            }}
                        />
                        <Column
                            title="Output Type"
                            width={120}
                            key="output"
                            dataIndex="output"
                            render={(text) => (
                                <span>{text ? text.substring(1).toUpperCase() : "N/A"}</span>
                            )}
                        />
                        {!!admin && (
                            <React.Fragment>
                                <Column title="Assignee" width={130} key="assignee" className="text-cent"
                                        dataIndex='assignee'/>
                                <Column
                                    title="Input File"
                                    key="inputFile"
                                    width={130}
                                    className="text-center"
                                    render={(data) => {
                                        return data.fileLink && data.fileLink !== "null" ? (
                                            <OutputFile type="userinput" file={data.fileLink || null}/>
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />
                                <Column
                                    title="Human Transcript File"
                                    key="transcript"
                                    width={190}
                                    className="text-center"
                                    render={(data) => {
                                        return data.revisedTranscriptLink &&
                                        data.revisedTranscriptLink !== "null" ? (
                                            <OutputFile
                                                type="humanTranscript"
                                                file={data.revisedTranscriptLink || null}
                                            />
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />
                                <Column
                                    title="Human Translation File"
                                    key="transcript"
                                    width={190}
                                    className="text-center"
                                    render={(data) => {
                                        return data.revisedTranslationLink &&
                                        data.revisedTranslationLink !== "null" ? (
                                            <OutputFile
                                                type="humanTranslations"
                                                file={data.revisedTranslationLink || null}
                                            />
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />

                                <Column
                                    title="Transcript File"
                                    key="transcript"
                                    className="text-center"
                                    width={130}
                                    render={(data) => {
                                        return data.transcriptLink && data.transcriptLink !== "null" ? (
                                            <OutputFile
                                                type="transcript"
                                                file={data.transcriptLink || null}
                                            />
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />
                                <Column
                                    title="Translation File"
                                    key="translation"
                                    width={130}
                                    className="text-center"
                                    render={(data) => {
                                        return data.translationLink &&
                                        data.translationLink !== "null" ? (
                                            <OutputFile
                                                type="translation"
                                                file={data.translationLink || null}
                                            />
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />
                                <Column
                                    title="Output File"
                                    key="outputFile"
                                    width={130}
                                    className="text-center"
                                    render={(data) => {
                                        return data.outputLink && data.outputLink !== "null" ? (
                                            <OutputFile type="userinput" file={data.outputLink || null}/>
                                        ) : (
                                            "N/A"
                                        );
                                    }}
                                />
                                <Column
                                    title="Edit"
                                    key="edit"
                                    width={80}
                                    fixed="right"
                                    className="text-center"
                                    render={(data) => (
                                        <Button
                                            type="link"
                                            onClick={() => editRequest(data, true)}
                                            icon={<EditOutlined/>}
                                        />
                                    )}
                                />
                            </React.Fragment>
                        )}
                    </Table>
                </Col>
            </Row>
        </>
    );
};

export default RequestListView;
